var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.transcripts && _vm.transcripts.length)?_c('div',[_c('AthleteSectionSubheading',[_vm._v("Transcripts")]),_c('div',{staticClass:"mb-8 linkGrid"},_vm._l((_vm.sortedTranscripts),function(link){return _c('AthleteLinkCard',{key:link.id,staticClass:"w-full",attrs:{"document":link}})}),1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }